<template>
  <div class="actions-wrapper">
    <cherkizovo-add-cascading-elements-dialog
      v-if="card.user_id === user.id && $canAndRulesPass(scope.row, 'card_element.cascading_enable')"
      @cards-selected="cascadeElement(scope.row, $event)"
    >
      <el-button
        slot="reference"
        title="Каскадировать цель"
        class="table-action-button"
        type="default"
        round
        size="mini"
        icon="fas fa-share-alt"
        :loading="loading"
      />
    </cherkizovo-add-cascading-elements-dialog>
    <cherkizovo-get-cascading-elements-dialog
      v-if="card.user_id === user.id && $canAndRulesPass(scope.row, 'card_element.cascading_enable')"
      :element-id="scope.row.id"
    >
      <el-button
        slot="reference"
        title="Кому уже каскадирована цель"
        class="table-action-button"
        type="default"
        round
        size="mini"
        icon="fas fa-users"
        :loading="loading"
      />
    </cherkizovo-get-cascading-elements-dialog>
    <el-popconfirm
      v-if="$canAndRulesPass(scope.row, $permissions.CARD_ELEMENT.DELETE)"
      confirm-button-text='Да'
      cancel-button-text='нет'
      icon="fas fa-question"
      title="Вы уверены, что хотите удалить элемент?"
      @confirm="deleteElement(scope.row)"
    >
      <el-button
        slot="reference"
        class="table-action-button"
        type="default"
        round
        size="mini"
        icon="far fa-trash-alt"
        :loading="loading"
      >
      </el-button>
    </el-popconfirm>
  </div>
</template>

<script>
import requestSender from "@/api/base/requestSender";
import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import CherkizovoAddCascadingElementsDialog from "@/componentsCompany/cherkizovo/card/CherkizovoAddCascadingElementsDialog.vue";
import CherkizovoGetCascadingElementsDialog from "@/componentsCompany/cherkizovo/card/CherkizovoGetCascadingElementsDialog.vue";
import {mapGetters} from "vuex";

export default {
  name: 'cherkizovo-element-actions-table-column',
  components: {CherkizovoAddCascadingElementsDialog, CherkizovoGetCascadingElementsDialog, ClickToEdit},
  mixins: [ElementPropTableColumn],
  props: {
    scope: {type: Object, required: true},
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card:'card'
    }),
  },
  methods: {
    deleteElement(element) {
      this.loading = true;
      this.$api.card.deleteElement({
        id: element.id,
      })
        .then((data) => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Элемент успешно удален'
          });
        })
        .finally(() => {
          this.loading = false;
          this.$emit('elements-changed');
        })
    },
    cascadeElement(element, cards) {
      this.loading = true;
      let cardIds = [];

      cards.forEach(card => {
        cardIds.push(card.id);
      })

      if (cardIds) {
        requestSender('post', 'cherkizovo-cascading-card-element/cascading', {
          elementId: element.id,
          cardIds: cardIds,
        })
          .then(data => {
            this.$notify.success({
              title: 'Успех',
              message: 'Цель каскадирована'
            });
          })
          .finally(()=>{
            this.loading = false;
          })
      }
    }
  }
}
</script>

<style>
  .actions-wrapper {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
  }
</style>
